import type { ISODateTimeString } from '../BrandedTypes'

export const AccessControl = {
  V1: {
    TenantUserCreated: 'AccessControl.V1.UserCreated',
    TenantUserNameChanged: 'AccessControl.V1.UserNameChanged',
    TenantUserPhoneNumberChanged:
      'AccessControl.V1.UserMobilePhoneNumberChanged',
    TenantUserProfileImageChanged: 'AccessControl.V1.UserProfileImageChanged',
    TenantUserDeactivated: 'AccessControl.V1.UserDeactivated',
    TenantUserActivated: 'AccessControl.V1.UserActivationCommitted',
    TenantUserEmailChanged: 'AccessControl.V1.UserEmailChanged',
    DatabaseAccessGranted: 'AccessControl.V1.DatabaseAccessGranted',
    DatabaseAccessRevoked: 'AccessControl.V1.DatabaseAccessRevoked',
    TenantAdminGranted: 'AccessControl.V1.UserGrantedTenantAdminPrivileges',
    TenantAdminRevoked: 'AccessControl.V1.UserTenantAdminPrivilegesRevoked',
    AccessRoleCreated: 'AccessControl.V1.AccessRoleCreated',
    UserRoleAssigned: 'AccessControl.V1.UserRoleAssigned',
    UserRoleUnassigned: 'AccessControl.V1.UserRoleUnassigned',
    AccessRoleDeleted: 'AccessControl.V1.AccessRoleDeleted',
    PermissionsAddedToAccessRole:
      'AccessControl.V1.PermissionsAddedToAccessRole',
    PermissionsRemovedFromAccessRole:
      'AccessControl.V1.PermissionsRemovedFromAccessRole',
    AccessRoleNameChanged: 'AccessControl.V1.AccessRoleNameChanged',
    UserDeactivationScheduled: 'AccessControl.V1.UserDeactivationScheduled',
    UserReactivated: 'AccessControl.V1.UserReactivated',
    UserJobTitleChanged: 'AccessControl.V1.UserJobTitleChanged'
  }
} as const

export type TenantUserCreatedSignalRPayload = {
  activeFrom: ISODateTimeString
  activeTo: ISODateTimeString
  email: string
  fullName: string
  isTenantAdmin: boolean
  initials: string
  mobilePhoneNumber?: string
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
}

export type TenantUserNameChangedSignalRPayload = {
  fullName: string
  initials: string
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
}

export type TenantUserPhoneNumberChangedSignalRPayload = {
  mobilePhoneNumber?: string
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
}

export type TenantUserProfileImageChangedSignalRPayload = {
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
}

export type TenantUserReactivatedSignalRPayload = {
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
}

export type TenantUserDeactivatedSignalRPayload = {
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
}

export type TenantUserDeactivationScheduledSignalRPayload = {
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
  willBeDeactivatedAt: ISODateTimeString
}

export type TenantUserActivatedSignalRPayload = {
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
}

export type DatabaseAccessGrantedSignalRPayload = {
  databaseDisplayName: string
  databaseId: string
  grantId: string
  occuredAt: ISODateTimeString
  tenantId: string
  userFullName: string
  userId: string
}

export type DatabaseAccessRevokedSignalRPayload = {
  databaseDisplayName: string
  databaseId: string
  grantId: string
  occuredAt: ISODateTimeString
  tenantId: string
  userFullName: string
  userId: string
}

export type TenantAdminGrantedSignalRPayload = {
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
}

export type TenantAdminRevokedSignalRPayload = {
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
}

export type TenantUserEmailChangedSignalRPayload = {
  newEmail: string
  occuredAt: ISODateTimeString
  oldEmail: string
  tenantId: string
  userId: string
}

export type AccessRoleCreatedSignalRPayload = {
  description: string
  name: string
  roleId: string
  occuredAt: ISODateTimeString
}

export type UserRoleAssignmentAddedSignalRPayload = {
  agencyNodeId: string
  agencyNodeName: string
  occuredAt: ISODateTimeString
  roleAssignmentId: string
  roleId: string
  roleName: string
  userId: string
}

export type UserRoleAssignmentRemovedSignalRPayload = {
  agencyNodeId: string
  agencyNodeName: string
  occuredAt: ISODateTimeString
  roleAssignmentId: string
  roleId: string
  roleName: string
  userId: string
}

export type AccessRoleDeletedSignalRPayload = {
  name: string
  occuredAt: ISODateTimeString
  roleId: string
}

export type PermissionsAddedToAccessRoleSignalRPayload = {
  occuredAt: ISODateTimeString
  permissionCodes: string[]
  roleId: string
}

export type AccessRoleNameChangedSignalRPayload = {
  name: string
  occuredAt: ISODateTimeString
  roleId: string
}

export type PermissionsRemovedFromAccessRoleSignalRPayload = {
  occuredAt: ISODateTimeString
  permissionCodes: string[]
  roleId: string
}

export type UserJobTitleChangedSignalRPayload = {
  jobTitle: string | null
  occuredAt: ISODateTimeString
  tenantId: string
  userId: string
}
